"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tavazzano-con-villavesco": {
    "2dc2f96a": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "ca-angelo": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b548a992": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-antegnatica": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ac84bdb2": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-bagnolo": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "93c1217a": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-belfuggito": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a12071be": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-ca-cesario": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51aa13cb": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-ca-de-zecchi": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "628d5ef0": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-ca-del-ferro": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ee2b5681": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-canovette": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "501cb4a8": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-ense": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "759d84e4": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-tavazzano-vecchio": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2accd096": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-vho": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "269abb22": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-zelasche": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4937a1af": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-zelaschine": [{
      "hkey": "c468b638",
      "slug": "tavazzano-con-villavesco",
      "name": "Tavazzano con Villavesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;